<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
html,body {
  width:100%;
  height:100%;
}
body {
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue